import { useFeatureFlags } from '@usap/core'

const useIsDifmPersistenceEnabled = () => {
  const { difm_psalgo: difmPersistence } = useFeatureFlags()
  return Boolean(difmPersistence)
}

export default useIsDifmPersistenceEnabled
